import { useCallback, useRef,useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isNotEmpty } from "../../../helpers/StringHelpers"
import { Option } from "../../../services/ntuc/userService/staticData"
import { BankNameValidator } from "../../../services/validation/bank-details-form/BankNameValidator"
import { StaticDataContext } from "../../../views/signup-flow/SignupFormPage/SignupFormPage"
import { DropDown } from "../../DropDown/DropDown"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const BankNameField = (props: FormFieldProps<Option>) => {
    const { t } = useTranslation(`signup`)
    const {
        defaultValue,
        handleChange,
        errorText,
    } = props

    const staticData = useContext(StaticDataContext)
    const [errorMessage, setErrorMessage] = useState(errorText ?? ``)
    const [value, setValue] = useState(``)

    useEffect(() => {
        setErrorMessage(errorText ?? ``)
    }, [errorText])

    const validateField = () => {
        const validator = new BankNameValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }

    const handleOnChange = useCallback((option: Option) => {
        setValue(option.value)
        handleChange(option)
    }, [handleChange])

    const initRef = useRef(false)

    // ensure internal value is set from provided defaultValue so validation/display are correct
    useEffect(() => {
        if (!initRef.current && defaultValue?.code && staticData?.bank) {
            const matched = staticData.bank.find((option) => option.code === defaultValue.code)
            if (matched) {
                setValue(matched.value)
                handleChange(matched)
                initRef.current = true
            }
        }
    }, [defaultValue?.code, staticData?.bank, handleChange])

    const defaultOption = staticData?.bank?.find(
        (option) => option.code === defaultValue?.code,
    )

    return (
        <DropDown
            title={t(`bank_name`)}
            options={staticData?.bank ?? []}
            showError={isNotEmpty(errorMessage)}
            errorMessage={t(errorMessage)}
            defaultValue={defaultOption}
            onChange={handleOnChange}
            onBlur={validateField}
        />
    )
}

export { BankNameField }
